/**
 * 功能描述：任务常量定义 <br>
 * 〈〉
 * @Author CHU
 * @Date 16:12 2021/2/19
 * @Version 1.0.0
 **/

// 资源目录的长度索引
export const CATALOG_LENGTH = 5;

// 资源目录值的位置索引
export const CATALOG_INDEX = 4;
